import React from 'react';
import { useCookies } from 'react-cookie';
import Avatar from 'react-avatar';

import useUserData from '../util/hooks/useUserData'
import useAuthorizeUrl from '../util/hooks/useAuthorizeUrl'

import styled from 'styled-components';
import logoutIcon from './logout.svg';

import { accessTokenCookieName, idTokenCookieName, oauthRedirectPath, pkceVerifierCookieName } from '../util/constants';

const UserWrapper = styled.div`
	line-height: 40px;
	color: #000;
	display: flex;
	align-items: center;
	justify-content: flex-end;
`;

const UserImage = styled.div`
	width: 35px;
	height: 35px;
	line-height: 35px;
`;

const UserName = styled.div`
	line-height: 16px;
	color: #2F2F2F;
	font-size: 14px;
	margin: 0 24px 0 12px;

	@media (max-width: 600px) {
		margin: 0 6px;
	}
`;

const StyledLink = styled.a`
	line-height: 2em;
	padding: 5px 26px;
	font-size: 13px;
	font-weight: 500;
	text-decoration: none;
	background-color: #2979FF;
	border-radius: 50px;
	color: #FFF;
	cursor: pointer;
	transition: 200ms ease-in;

	&:hover {
		opacity: 0.9;
	}
`;

const Icon = styled.img`
	width: 24px;
	height: 24px;
`;

const Button = styled.button`
	background: none;
	border: none;
	padding: 0;
	margin: 0;
	cursor: pointer;
	display: block;
	height: 24px;
`;

export default () => {

	const isLoginCallback = window.location.pathname === oauthRedirectPath;

	const { isLoading, isLogged, firstname, lastname, profilePicture } = useUserData();
	const authorizeUrl = useAuthorizeUrl(!isLoginCallback && !isLoading && !isLogged);

	const [, , removeCookie] = useCookies([accessTokenCookieName, idTokenCookieName, pkceVerifierCookieName]);

	if(isLoading) {
		return null;
	}

	if(authorizeUrl) {
		return (
			<UserWrapper>
				<StyledLink href={authorizeUrl} target="_self" title="Login">Login</StyledLink>
			</UserWrapper>
		);
	}

	if(!isLogged) {
		return null;
	}

	const handleLogout = () => {
		removeCookie(accessTokenCookieName, { path: '/' });
		removeCookie(idTokenCookieName, { path: '/' });
		removeCookie(pkceVerifierCookieName, { path: '/' });
		window.location.reload();
	};

	return (
		<UserWrapper>
			<UserImage>
				<Avatar
					src={profilePicture}
					name={`${firstname} ${lastname}`}
					maxInitials={2}
					size={32}
					textSizeRatio={2.5}
					round={true}
					style={{ verticalAlign: 'inherit' }}
				/>
			</UserImage>
			<UserName>{firstname} {lastname}</UserName>
			<Button onClick={handleLogout}>
				<Icon src={logoutIcon} alt="Logout"/>
			</Button>
		</UserWrapper>
	);
}
